// Screen size and input type, for phones, tablets and narrow windows.
import { useSyncExternalStore } from 'react';

/** Wide enough to keep the explorer beside the tabs; narrower, it slides in over them. */
export const EXPLORER_DOCKS = '(min-width: 768px)';
/** Wide enough to keep the inspector beside the tabs as well. */
export const INSPECTOR_DOCKS = '(min-width: 1024px)';
/** A phone, or a window as narrow as one. */
export const PHONE = '(max-width: 767px)';
/** A finger rather than a mouse. */
export const TOUCH = '(pointer: coarse)';

export function matches(query: string): boolean {
  return typeof window !== 'undefined' && typeof window.matchMedia === 'function' && window.matchMedia(query).matches;
}

export function useMedia(query: string): boolean {
  return useSyncExternalStore(
    (onChange) => {
      const list = window.matchMedia(query);
      list.addEventListener('change', onChange);
      return () => list.removeEventListener('change', onChange);
    },
    () => matches(query),
    () => false,
  );
}
